import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import AuthRoute from "./AuthRoute";

import Login from "pages/Login";
import LoginCallback from "pages/LoginCallback";
import NotFound from "pages/NotFound";
import Home from "pages/Home";

import CompanyIndex from "pages/Company/Index";
import CompanyEdit from "pages/Company/Edit";
import CompanyCreate from "pages/Company/Create";
import CompanySmsReload from "pages/Company/SmsReload";
import CompanyAddSmsReload from "pages/Company/SmsReload/Add";
import CompanyEditSmsReload from "pages/Company/SmsReload/Edit";

import PromotionTypeIndex from "pages/PromotionType/Index";
import PromotionTypeEdit from "pages/PromotionType/Edit";
import PromotionTypeCreate from "pages/PromotionType/Create";

import CompanyProfileTypeIndex from "pages/CompanyProfileType/Index";
import CompanyProfileTypeEdit from "pages/CompanyProfileType/Edit";
import CompanyProfileTypeCreate from "pages/CompanyProfileType/Create";

import RateLimitIndex from "pages/RateLimit/Index";
import RateLimitEdit from "pages/RateLimit/Edit";
import RateLimitCreate from "pages/RateLimit/Create";

import ProductStatusIndex from "pages/ProductStatus/Index";
import ProductStatusEdit from "pages/ProductStatus/Edit";
import ProductStatusCreate from "pages/ProductStatus/Create";

import HighlightActionIndex from "pages/HighlightAction/Index";
import HighlightActionEdit from "pages/HighlightAction/Edit";
import HighlightActionCreate from "pages/HighlightAction/Create";

import OrderStatusIndex from "pages/OrderStatus/Index";
import OrderStatusEdit from "pages/OrderStatus/Edit";
import OrderStatusCreate from "pages/OrderStatus/Create";

import UserIndex from "pages/User/Index";
import UserCreate from "pages/User/Create";
import UserEdit from "pages/User/Edit";

import RoleIndex from "pages/Role/Index";
import RoleCreate from "pages/Role/Create";
import RoleEdit from "pages/Role/Edit";

import PermissionIndex from "pages/Permission/Index";
import PermissionCreate from "pages/Permission/Create";
import PermissionEdit from "pages/Permission/Edit";

import AvailableGatewayIndex from "pages/AvailableGateway/Index";
import AvailableGatewayCreate from "pages/AvailableGateway/Create";
import AvailableGatewayEdit from "pages/AvailableGateway/Edit";

export default () => {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/login" component={Login} />
        <Route exact path="/login/oauth/callback" component={LoginCallback} />

        <AuthRoute exact path="/dashboard" component={CompanyIndex} />

        <AuthRoute
          exact
          path="/promotion-types"
          component={PromotionTypeIndex}
        />
        <AuthRoute
          exact
          path="/promotion-types/create"
          component={PromotionTypeCreate}
        />
        <AuthRoute
          exact
          path="/promotion-types/:promotionTypeId/edit"
          component={PromotionTypeEdit}
        />

        <AuthRoute
          exact
          path="/highlight-actions"
          component={HighlightActionIndex}
        />
        <AuthRoute
          exact
          path="/highlight-actions/create"
          component={HighlightActionCreate}
        />
        <AuthRoute
          exact
          path="/highlight-actions/:highlightActionId/edit"
          component={HighlightActionEdit}
        />

        <AuthRoute
          exact
          path="/available-gateways"
          component={AvailableGatewayIndex}
        />
        <AuthRoute
          exact
          path="/available-gateways/create"
          component={AvailableGatewayCreate}
        />
        <AuthRoute
          exact
          path="/available-gateways/:gatwayId/edit"
          component={AvailableGatewayEdit}
        />
        <AuthRoute
          exact
          path="/company-profile-types"
          component={CompanyProfileTypeIndex}
        />
        <AuthRoute
          exact
          path="/company-profile-types/create"
          component={CompanyProfileTypeCreate}
        />
        <AuthRoute
          exact
          path="/company-profile-types/:companyProfileTypeId/edit"
          component={CompanyProfileTypeEdit}
        />

        <AuthRoute
          exact
          path="/product-status"
          component={ProductStatusIndex}
        />
        <AuthRoute
          exact
          path="/product-status/create"
          component={ProductStatusCreate}
        />
        <AuthRoute
          exact
          path="/product-status/:productStatusId/edit"
          component={ProductStatusEdit}
        />

        <AuthRoute exact path="/order-status" component={OrderStatusIndex} />
        <AuthRoute
          exact
          path="/order-status/create"
          component={OrderStatusCreate}
        />
        <AuthRoute
          exact
          path="/order-status/:orderStatusId/edit"
          component={OrderStatusEdit}
        />

        <AuthRoute exact path="/rate-limits" component={RateLimitIndex} />
        <AuthRoute
          exact
          path="/rate-limits/create"
          component={RateLimitCreate}
        />
        <AuthRoute
          exact
          path="/rate-limits/:rateLimitId/edit"
          component={RateLimitEdit}
        />

        <AuthRoute exact path="/companies" component={CompanyIndex} />
        <AuthRoute exact path="/companies/create" component={CompanyCreate} />
        <AuthRoute
          exact
          path="/companies/:companyId/edit"
          component={CompanyEdit}
        />

        <AuthRoute
          exact
          path="/companies/:companyId/sms-reloads"
          component={CompanySmsReload}
        />
        <AuthRoute
          exact
          path="/companies/:companyId/sms-reloads/add"
          component={CompanyAddSmsReload}
        />
        <AuthRoute
          exact
          path="/companies/:companyId/sms-reloads/:smsReloadId/edit"
          component={CompanyEditSmsReload}
        />

        <AuthRoute exact path="/users" component={UserIndex} />
        <AuthRoute exact path="/users/create" component={UserCreate} />
        <AuthRoute exact path="/users/:userId/edit" component={UserEdit} />

        <AuthRoute exact path="/roles" component={RoleIndex} />
        <AuthRoute exact path="/roles/create" component={RoleCreate} />
        <AuthRoute exact path="/roles/:roleId/edit" component={RoleEdit} />

        <AuthRoute exact path="/permissions" component={PermissionIndex} />
        <AuthRoute
          exact
          path="/permissions/create"
          component={PermissionCreate}
        />
        <AuthRoute
          exact
          path="/permissions/:permissionId/edit"
          component={PermissionEdit}
        />

        <AuthRoute component={NotFound} />
      </Switch>
    </Router>
  );
};



// WEBPACK FOOTER //
// ./src/routes/index.js